// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section.base-panel-section{margin-bottom:12px;overflow:hidden}section.base-panel-section:last-child{margin-bottom:0}section.base-panel-section header{margin-bottom:12px;width:100%}section.base-panel-section header h4{display:inline-block;font-size:12px;text-transform:uppercase;margin:0}section.base-panel-section header .base-panel-section__toolbar{float:right;color:#fa0019}", ""]);
// Exports
module.exports = exports;
